import { Component, computed, input } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
    selector: "profile-image",
    styleUrls: ["./profile-image.component.scss"],
    template: ` <ng-container>
    <!-- Size of profile image decided by parent heigth and width -->
    <div
      class="profile-image-inner"
      [ngStyle]="{
        'background-image': cssImageUrl(),
      }"
    ></div>
  </ng-container>`,
    standalone: true,
    imports: [NgStyle],
})
export class ProfileImageComponent {
  imageUrl = input<string>("");
  cssImageUrl = computed(() => {
    if (this.imageUrl()) {
      var cssImageUrl = `url('${this.imageUrl() ?? ""}')`;
      cssImageUrl += ", url(/assets/img/default-profile.svg)";
    } else {
      var cssImageUrl = "url(/assets/img/default-profile.svg)";
    }
    return cssImageUrl;
  });
}
